import { Actions, createStore } from '@bpd-library/utilities';

export interface ModalState {
    modals: {
        [key: string]: {
            active: boolean;
            closeRequest?: boolean;
        };
    };
}

type ModalStoreAction =
    | 'addModal'
    | 'openModal'
    | 'closeModal'
    | 'requestCloseModal'
    | 'dismissCloseModal'
    | 'closeAllModals';

const initialState: ModalState = {
    modals: {},
};

const actions: Actions<ModalStoreAction, ModalState> = {
    addModal: (state: ModalState, payload: { id: string }) => {
        state.modals = {
            ...state.modals,
            [payload.id]: {
                active: false,
            },
        };

        return state;
    },
    openModal: (state: ModalState, payload: { id: string }) => {
        state.modals = {
            ...state.modals,
            [payload.id]: {
                active: true,
                closeRequest: false,
            },
        };
        return state;
    },
    closeModal: (state: ModalState, payload: { id: string }) => {
        state.modals = {
            ...state.modals,
            [payload.id]: {
                active: false,
                closeRequest: false,
            },
        };

        return state;
    },
    requestCloseModal: (state: ModalState, payload: { id: string }) => {
        state.modals = {
            ...state.modals,
            [payload.id]: {
                active: true,
                closeRequest: true,
            },
        };

        return state;
    },
    dismissCloseModal: (state: ModalState, payload: { id: string }) => {
        state.modals = {
            ...state.modals,
            [payload.id]: {
                active: true,
                closeRequest: false,
            },
        };

        return state;
    },

    closeAllModals: (state: ModalState) => {
        Object.keys(state.modals).map((id) => {
            state.modals = {
                ...state.modals,
                [id]: {
                    active: false,
                    closeRequest: false,
                },
            };
        });

        return state;
    },
};

export const modalStore = createStore<ModalState, ModalStoreAction>({
    initialState,
    actions,
});

export const addModal = (id: string) => {
    modalStore.dispatch('addModal', { id });
};

export const openModal = (id: string) => {
    modalStore.dispatch('openModal', { id });
};

export const closeModal = (id: string) => {
    modalStore.dispatch('closeModal', { id });
};

export const requestCloseModal = (id: string) => {
    modalStore.dispatch('requestCloseModal', { id });
};

export const dismissCloseModal = (id: string) => {
    modalStore.dispatch('dismissCloseModal', { id });
};

export const closeAllModals = () => {
    modalStore.dispatch('closeAllModals');
};

export const modalExists = (id: string) => {
    const modals = modalStore.getState().modals;
    return Boolean(modals[id]);
};

export const isModalActive = (id: string) => {
    const modals = modalStore.getState().modals;
    return Boolean(modals[id]?.active);
};
